import { render } from "./UnCryptoMenu.vue?vue&type=template&id=3a190157"
import script from "./UnCryptoMenu.vue?vue&type=script&lang=js"
export * from "./UnCryptoMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__